import { ImageIcon } from 'lucide-react';
import { galleryItemId, type GalleryItem, type GalleryStatus } from '@/features/gallery/types/gallery';
import { GalleryCard } from './GalleryCard';

type GalleryGridProps = {
  isPending: boolean;
  items: GalleryItem[];
  status: GalleryStatus;
  canDelete: boolean;
  onViewDetail: (item: GalleryItem) => void;
  onDelete: (item: GalleryItem) => void;
};

export function GalleryGrid({
  isPending,
  items,
  status,
  canDelete,
  onViewDetail,
  onDelete,
}: GalleryGridProps) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {isPending ? (
        Array.from({ length: 8 }).map((_, i) => (
          <div
            key={i}
            className="camp-skeleton h-[240px] rounded-2xl border border-[var(--dash-line)]"
          />
        ))
      ) : items.length > 0 ? (
        items.map((item) => (
          <GalleryCard
            key={galleryItemId(item)}
            item={item}
            canDelete={canDelete}
            showDelete={status !== 'APPROVE'}
            onViewDetail={onViewDetail}
            onDelete={onDelete}
          />
        ))
      ) : (
        <div className="col-span-full rounded-2xl border border-dashed border-[var(--dash-line)] bg-white px-4 py-16 text-center">
          <ImageIcon className="mx-auto h-8 w-8 text-[var(--dash-muted)] opacity-40" />
          <p className="mt-3 mb-0 text-sm font-semibold text-[var(--dash-ink)]">
            No gallery items
          </p>
          <p className="mt-1 mb-0 text-xs text-[var(--dash-muted)]">
            Nothing in {status.toLowerCase()} yet.
          </p>
        </div>
      )}
    </div>
  );
}
